import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import qs from 'query-string';
import { Button, Form, InputPassword, Modal } from '../../components/ui';
import { setPassword } from '../../redux/password/slice';
import { DEFAULT_RULES } from '../../consts/formRules';
import { selectSetPasswordLoading, selectSetPasswordFailed } from '../../redux/password/selectors';
import { SetPasswordStyleWrapper, SetPasswordTextWrapper } from './SetPassword.style';
import PasswordRules from './PasswordRules';

/**
 * Functional component for the set password process.
 * Allows users to set a new password using a token from the query string.
 * @property {Function} setPassword - function to trigger the set password process.
 * @property {Boolean} setPasswordFailed - boolean indicating if there was an error during set password.
 * @property {Boolean} setPasswordLoading - boolean indicating if the set password process is loading.
 */

const SetPassword = ({ setPassword, setPasswordFailed, setPasswordLoading }) => {
  const [form] = Form.useForm();
  const { resetFields, validateFields } = form;

  const [passwordValue, setPasswordValue] = useState('');
  const location = useLocation(); // Use useLocation to get the location object
  const navigate = useNavigate(); // Use useNavigate to get the navigate function
  const token = qs.parse(location.search, { ignoreQueryPrefix: true }).token || null;

  // Reset form fields when the component unmounts
  useEffect(() => {
    return () => {
      resetFields();
    };
  }, []);

  const handleFormValuesChange = (changedValues) => {
    setPasswordValue(changedValues.password);
  };

  // Handle form submission and trigger set password process
  const handleSubmit = () =>
    validateFields()
      .then((values) => {
        if (setPasswordLoading) {
          return;
        }
        const { password } = values;
        setPassword({ token, newPassword: password, navigate: navigate });
      })
      .catch(() => {});

  return (
    <Modal
      className="modal-no-padding"
      title="Neues Passwort"
      style={{ top: 140 }}
      open
      closable={false}
      mask={false}
      createNoPointerEventsContainer
      footer={null}
    >
      <SetPasswordStyleWrapper>
        <SetPasswordTextWrapper>Bitte vergeben Sie ein neues Passwort.</SetPasswordTextWrapper>
        <Form form={form} onValuesChange={handleFormValuesChange}>
          <Form.Item
            className="set-password-input"
            label="Neues Passwort"
            name="password"
            rules={DEFAULT_RULES.INPUT_REQUIRED}
          >
            <InputPassword autoComplete="current-password" status={setPasswordFailed ? 'error' : ''} />
          </Form.Item>
          <PasswordRules password={passwordValue} />
          <div className="set-password-button-wrapper">
            <Button type="primary" onClick={handleSubmit}>
              Speichern
            </Button>
          </div>
        </Form>
      </SetPasswordStyleWrapper>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  setPasswordFailed: selectSetPasswordFailed(state),
  setPasswordLoading: selectSetPasswordLoading(state)
});

const mapDispatchToProps = { setPassword };

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);
